import { createRequest } from './pay'

const serviceName = 'pay.api';

/**
* 设置展示
*/
export const confList = createRequest<
 undefined,
 {
   code: number;
   data: {
     /** Telegram客服 */
     telegram_customer_id: string;
   };
   msg: string;
   request_id: string;
 }
>("confList", () => ({ url: `/conf/config`, method: "GET", headers: { "Service-Name": serviceName } }));

/**
* 设置更新
*/
export const confUpdate = createRequest<
 {
   requestBody?: {
     /** Telegram客服 */
     telegram_customer_id: string;
   };
 },
 {
   code: number;
   data: {
     /** 是否自动提现 0 关闭 1 开启 */
     cash_auto: number;
     /** Tron提现地址 */
     cash_binance_address: string;
     /** Ethereum提现地址 */
     cash_ethereum_address: string;
     /** Binance提现地址 */
     cash_tron_address: string;
     /** Telegram客服 */
     telegram_customer_id: string;
   };
   msg: string;
   request_id: string;
 }
>("confUpdate", ({ requestBody }) => ({
 url: `/conf/update`,
 method: "POST",
 data: requestBody,
 headers: { "Content-Type": "application/json", "Service-Name": serviceName },
}));

/**
* 获取AWS临时授权
*/
export const fileAwsToken = createRequest<
 undefined,
 {
   code: number;
   data: {
     Credentials: { AccessKeyId: string; Expiration: string; SecretAccessKey: string; SessionToken: string };
     ResultMetadata: {};
   };
   msg: string;
   request_id: string;
 }
>("fileAwsToken", () => ({ url: `/file/aws_token`, method: "GET", headers: { "Service-Name": serviceName } }));

/**
* 握手协议
*/
export const initHandshake = createRequest<
 undefined,
 {
   code: number;
   data: {
     app_name: string;
     /** APP版本号 */
     app_version: string;
     file_bucket: string;
     file_domain: string;
     file_region: string;
     session_id: string;
     telegram_business_customer_id: string;
     telegram_channel_id: string;
     telegram_customer_id: string;
   };
   msg: string;
   request_id: string;
 }
>("initHandshake", () => ({ url: `/init/handshake`, method: "GET", headers: { "Service-Name": serviceName } }));

/**
* 是否授权足够token
*/
export const swapAllownced = createRequest<
 {
   order_id: string;
 },
 { code: number; data: { amount: string; decimals: number }; msg: string; request_id: string }
>("swapAllownced", ({ order_id }) => ({
 url: `/swap/allownced`,
 method: "GET",
 params: {
   order_id,
 },
 headers: { "Service-Name": serviceName },
}));

/**
* 创建兑换订单
*/
export const swapCreate = createRequest<
 {
   requestBody?: {
     from_address?: string;
     /** 支付币种合约地址 */
     from_token_address: string;
     /** 支付金额 */
     from_token_amount: string;
     /** 支付链 */
     from_token_chain: string;
     /** 是否平台授权 */
     is_platform_approve: number;
     /** 接收地址 */
     to_address: string;
     /** 兑换币种合约地址 */
     to_token_address: string;
     /** 兑换链 */
     to_token_chain: string;
   };
 },
 { code: number; data: ISwapDetail; msg: string; request_id: string }
>("swapCreate", ({ requestBody }) => ({
 url: `/swap/create`,
 method: "POST",
 data: requestBody,
 headers: { "Content-Type": "application/json", "Service-Name": serviceName },
}));

/**
* 获取触发跨链桥合约的参数
*/
export const swapGetSignTx = createRequest<
 {
   order_id: string;
 },
 { code: number; data: ISginTx; msg: string; request_id: string }
>("swapGetSignTx", ({ order_id }) => ({
 url: `/swap/sign_tx`,
 method: "GET",
 params: {
   order_id,
 },
 headers: { "Service-Name": serviceName },
}));

/**
* 询价
*/
export const swapQute = createRequest<
 {
   fromTokenAddress: string;
   fromTokenAmount: string;
   fromTokenChain: string;
   is_platform_approve: number;
   toTokenAddress: string;
   toTokenChain: string;
   userAddr?: string;
 },
 { code: number; data: IQuote; msg: string; request_id: string }
>(
 "swapQute",
 ({
   fromTokenAddress,
   toTokenAddress,
   fromTokenAmount,
   fromTokenChain,
   toTokenChain,
   userAddr,
   is_platform_approve,
 }) => ({
   url: `/swap/quote`,
   method: "GET",
   params: {
     fromTokenAddress,
     toTokenAddress,
     fromTokenAmount,
     fromTokenChain,
     toTokenChain,
     userAddr,
     is_platform_approve,
   },
   headers: { "Service-Name": serviceName },
 }),
);

/**
* 币种列表
*/
export const swapTokenList = createRequest<
 undefined,
 { code: number; data: (ITokenDetail | null)[]; msg: string; request_id: string }
>("swapTokenList", () => ({ url: `/swap/token_list`, method: "GET", headers: { "Service-Name": serviceName } }));

/**
* 兑换详情
*/
export const swapTransDataDetail = createRequest<
 {
   order_id: string;
 },
 { code: number; data: ISwapDetail | null; msg: string; request_id: string }
>("swapTransDataDetail", ({ order_id }) => ({
 url: `/swap/trans_data_detail`,
 method: "GET",
 params: {
   order_id,
 },
 headers: { "Service-Name": serviceName },
}));

/**
* 兑换订单查询
*/
export const swapTransDataList = createRequest<
 {
   from_address: string;
   page: number;
   page_size: number;
 },
 { code: number; data?: ISwapDetail[]; msg: string; request_id: string }
>("swapTransDataList", ({ page, page_size, from_address }) => ({
 url: `/swap/trans_data_list`,
 method: "GET",
 params: {
   page,
   page_size,
   from_address,
 },
 headers: { "Service-Name": serviceName },
}));

/**
* 转账地址
*/
export const swapTransferAddress = createRequest<
 undefined,
 { code: number; data: ITransferAddress[]; msg: string; request_id: string }
>("swapTransferAddress", () => ({
 url: `/swap/transfer_address`,
 method: "GET",
 headers: { "Service-Name": serviceName },
}));

/**
* 触发合约后更新订单信息
*/
export const updateHash = createRequest<
 {
   requestBody?: { hash: string; order_id: string };
 },
 { code: number; data: null; msg: string; request_id: string }
>("updateHash", ({ requestBody }) => ({
 url: `/swap/update_hash`,
 method: "POST",
 data: requestBody,
 headers: { "Content-Type": "application/json", "Service-Name": serviceName },
}));

export interface IChengGong {
 code: number;
 data: {};
 msg: string;
 request_id: string;
}

export interface IPagination {
 cursor?: string;
 /** 是否还有下一页 */
 has_more: boolean;
 page: number;
 page_size: number;
 total?: number;
}

export interface IQuote {
 /** 兑换金额（带精度） */
 amountOutMin: string;
 chainFee: string;
 /** 触发合约地址 */
 contractAddress: string;
 /** 最大兑换金额（不带精度） */
 depositMax: string;
 /** 最小兑换金额（不带精度） */
 depositMin: string;
 dex: string;
 /** 预计兑换时间 */
 estimatedTime: number;
 fee: number;
 feeToken: string;
 /** 支付金额 */
 fromTokenAmount: string;
 /** 支付币种精度 */
 fromTokenDecimal: number;
 logoUrl: string;
 path: string[];
 /** 兑换金额（不带精度） */
 toTokenAmount: string;
 /** 兑换币种精度 */
 toTokenDecimal: number;
}

export interface ISginTx {
 /** evm等待签名数据 */
 data: string;
 /** tvm调用者地址 */
 fromAddress: string;
 /** tvm要触发的合约函数 */
 functionName: string;
 /** tvm附加金额（原生币种兑换会有值） */
 options: { callValue: string; feeLimit: number };
 /** tvm合约输入参数 */
 parameter: { type: string; value: string }[];
 /** evm跨链桥合约地址 */
 to: string;
 tronRouterAddrees: string;
 tronRouterAddress: string;
 /** evm附加金额（原生币种兑换会有值） */
 value: string;
}

export interface ISwapDetail {
 /** 代理id */
 agent_id: number;
 /** 授权地址 */
 approve_address: string;
 /** 到账时间 */
 arrival_time: number;
 /** 跨链桥订单ID */
 bridgers_order_id: string;
 /** 跨链桥收取手续费 */
 chainFee: string;
 /** 跨链桥智能合约地址 */
 contract_address: string;
 /** 创建时间 */
 create_time: number;
 /** 触发跨链桥合约hash查看地址 */
 deposit_hash_explore: string;
 /** 支付最大金额，不带精度 */
 deposit_max: string;
 /** 支付最低金额，不带精度 */
 deposit_min: string;
 /** 跨链桥名称 */
 dex: string;
 /** 设备号 */
 equipment_no: string;
 /** 预计到账时间 */
 estimated_time: number;
 /** 跨链桥的手续费 */
 fee: number;
 /** 跨链桥收取token费用 */
 fee_token: string;
 /** 支付地址 */
 from_address: string;
 /** 支付代币地址，原生币种用0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee表示 */
 from_token_address: string;
 /** 支付金额，带精度 */
 from_token_amount: string;
 /** 支付公链 */
 from_token_chain: string;
 /** 支付币精度 */
 from_token_decimal: number;
 /** 支付币种 */
 from_token_symbol: string;
 from_token_symbol_show:string;
 to_token_symbol_show:string;
 handle_status: number;
 /** 兑换ID */
 id: number;
 /** 授权地址是否授权足够资金0否1是 */
 is_approve: number;
 /** 是否平台授权兑换 0 用户授权 1 平台授权 2 备付金 */
 is_platform_approve: number;
 /** 收银台或客户端语言，中文zh_cn，英文en */
 locale: string;
 /** 商户主键ID */
 merchant_id: number;
 /** 平台订单ID */
 order_id: string;
 /** 平台源 */
 platform_source: string;
 /** 利润 */
 profit: string;
 /** 到账hash查看地址 */
 receive_hash_explore: string;
 /** 退款金额 */
 refund_coin_amount: number;
 /** 退款hash */
 refund_hash: string;
 /** 退款hash查看地址 */
 refund_hash_explore: string;
 /** 退款原因 */
 refund_reason: string;
 /** 备付金转账地址 */
 reserve_address: string;
 /** 渠道号 */
 source_flag: string;
 /** wait_deposit_send: ''等待存币'',\nwait_deposit_send_fail: ''存币失败'',\nwait_exchange_push: ''正在兑换中...'',\nwait_exchange_return: ''正在兑换中...'',\nwait_exchange_return_success: ''正在兑换中...'',\nwait_receive_send: ''兑换完成，等待发币'',\nwait_enough_send:''正在发币中...''\nwait_receive_confirm: ''发币确认中...'',\nreceive_complete: ''发币完成'',\nwait_refund_send: ''等待退币'',\nwait_refund_confirm: ''退币确认中...'',\nrefund_complete: ''退币完成'',\ntimeout: ''兑换超时'',\nERROR: ''正在兑换中...'',\nwait_for_information:''请联系客服''\n' */
 status: string;
 /** 触发跨链桥合约hash */
 swap_hash: string;
 /** 兑换目标地址 */
 to_address: string;
 /** 到账hash */
 to_hash: string;
 /** 兑换目标代币地址，原生币种用0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee表示 */
 to_token_address: string;
 /** 兑换目标金额，带精度 */
 to_token_amount: string;
 /** 兑换目标链 */
 to_token_chain: string;
 /** 兑换目标币种精度 */
 to_token_decimal: number;
 /** 兑换目标币种 */
 to_token_symbol: string;
 /** 转账给平台授权的金额（加随机金额匹配） */
 transfer_approve_address_amount: string;
 /** 转账到平台授权地址hash */
 transfer_hash: string;
 /** 触发跨链桥智能合约金额 */
 trigger_contract_amount: string;
 /** 触发跨链桥智能合约的手续费 */
 trigger_contract_fee: string;
}

export interface ISwapList {
 createTime: string;
 depositHashExplore: string;
 dexName: string;
 equipmentNo: string;
 estimatedTime: number;
 fromAddress: string;
 fromAmount: string;
 fromChain: string;
 fromCoinCode: string;
 fromDecimals: string;
 fromGas: null;
 fromTokenAddress: string;
 fromTokenAmount: string;
 hash: string;
 id: number;
 orderId: string;
 platformSource: string;
 receiveHashExplore: string;
 refundCoinAmt: string;
 refundHash: string;
 refundHashExplore: string;
 refundReason: string;
 slippage: string;
 source: string;
 status: string;
 toAddress: string;
 toAmount: string;
 toChain: string;
 toCoinCode: string;
 toDecimals: string;
 toGas: null;
 toHash: string;
 toTokenAddress: string;
 toTokenAmount: string;
}

export interface ITokenDetail {
 /** 币种合约地址 */
 address: string;
 /** 币种所属链 */
 chain: string;
 /** 币种所属链ID */
 chainId: string;
 /** 币种精度 */
 decimals: number;
 isCrossEnable: number;
 /** 币种logo */
 logoURI: string;
 /** 币种名称 */
 name: string;
 /** 币种名称 */
 symbol: string;
 withdrawGas: number;
}

export interface ITransferAddress {
 address: string;
 approve_to_address: string;
 chain: string;
 chain_id: number;
 create_time: number;
 json_rpc: string;
}
